import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { EngineCreatePayload } from '@rossum/api-client/engines';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { engineKeys, mutationKey } from '../keys';

export const createEngineKey = () => mutationKey(['create_engine'] as const);

export const useCreateEngine = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationKey: createEngineKey(),
    mutationFn: (payload: EngineCreatePayload) =>
      api.request(endpoints.engines.create(payload)),
    onSuccess: engine => {
      notify.default({
        title: intl.formatMessage({
          id: 'containers.message.engineCreated',
        }),
      });
      queryClient.setQueryData(engineKeys.detail(engine.id), engine);
    },
  });
};
